import React, { useMemo, useState } from "react";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

const Portfolio = () => {
    const [activeFilter, setActiveFilter] = useState('*');
    const [zoomImageUrl, setZoomImageUrl] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const portfolioItems = [
        {
            id: "commercial 1",
            category: "commercial",
            //title: "Commercial 1",
            //label: "Commercial 1",
            description: "Medium Office, Elk City, OK, 73644",
            images: [
                'assets/images/commercial/c1/1.png',
                'assets/images/commercial/c1/2.png',
                'assets/images/commercial/c1/3.png',
                'assets/images/commercial/c1/1.jpeg',
                'assets/images/commercial/c1/2.jpeg',
                'assets/images/commercial/c1/3.jpeg',
            ]
        },
        {
            id: "commercial 2",
            category: "commercial",
            //title: "Commercial 2",
            //label: "Commercial 2",
            description: "Church, Channelview, TX, 77530",
            images: [
                'assets/images/commercial/c2/1.png',
                'assets/images/commercial/c2/2.png',
                'assets/images/commercial/c2/3.png',
                'assets/images/commercial/c2/4.png',
            ]
        },
        {
            id: "commercial 3",
            category: "commercial",
            //title: "Commercial 3",
            //label: "Commercial 3",
            description: "Lean Kitchen, Bentonville, AR, 72712",
            images: [
                'assets/images/commercial/c3/1.png',
                'assets/images/commercial/c3/2.png',
                'assets/images/commercial/c3/3.png',
                'assets/images/commercial/c3/4.jpeg',
            ]
        },
        {
            id: "residential 1",
            category: "residential",
            //title: "Residential 1",
            //label: "Residential 1",
            description: "House of Dream, Trout Creek, MT, 59874",
            images: [
                'assets/images/residential/r1/1.png',
                'assets/images/residential/r1/2.png',
                'assets/images/residential/r1/3.png',
                'assets/images/residential/r1/4.png',
            ]
        },
        {
            id: "residential 2",
            category: "residential",
            //title: "residential 2",
            //label: "residential 2",
            description: "House of Dream, Cougar, WA, 98616",
            images: [
                'assets/images/residential/r2/1.png',
                'assets/images/residential/r2/2.png',
                'assets/images/residential/r2/3.png',
                'assets/images/residential/r2/4.png',
            ]
        },
        {
            id: "residential 3",
            category: "residential",
            //title: "residential 3",
            //label: "residential 3",
            description: "House of Dream, Austin, TX, 78734",
            images: [
                'assets/images/residential/r3/1.png',
                'assets/images/residential/r3/2.png',
                'assets/images/residential/r3/3.png',
                'assets/images/residential/r3/1.jpeg',
            ]
        },
    ]
    // const portfolioItems = useMemo(() => {
    //     const makeCategory = (category, label, basePath) => Array.from({ length: 5 }).map((_, idx) => {
    //         const n = idx + 1;
    //         return {
    //             id: `${category}-${n}`,
    //             category,
    //             title: `${label} ${n}`,
    //             label,
    //             description: `${label} project ${n} — brief description goes here.`,
    //             imgCandidates: [
    //                 `${basePath}/${n}.jpg`,
    //                 `${basePath}/${n}.png`,
    //                 `${basePath}/${n}.jpeg`
    //             ]
    //         };
    //     });
    //     return [
    //         ...makeCategory('civil', 'Civil', 'assets/images/civil'),
    //         ...makeCategory('architecture', 'Architecture', 'assets/images/architecture'),
    //         ...makeCategory('mep', 'MEP', 'assets/images/mep')
    //     ];
    // }, []);

    const filtered = useMemo(() => (
        activeFilter === '*' ? portfolioItems : portfolioItems.filter(i => i.category === activeFilter)
    ), [activeFilter, portfolioItems]);

    return(
        <div>
        <Header/>
        <main id="main">
            <section id="breadcrumbs" class="breadcrumbs">
                <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                        <h2>Portfolio</h2>
                        <ol>
                            <li><a href="/">Home</a></li>
                            <li>Portfolio</li>
                        </ol>
                    </div>
                </div>
            </section>

            <section id="portfolio" class="portfolio">
                <div class="container" data-aos="fade-up">
                    <div class="row" data-aos="fade-up">
                        <div class="col-lg-12 d-flex justify-content-center">
                            <ul id="portfolio-flters">
                                <li class={activeFilter === '*' ? 'filter-active' : ''} onClick={() => setActiveFilter('*')}>All</li>
                                <li class={activeFilter === 'commercial' ? 'filter-active' : ''} onClick={() => setActiveFilter('commercial')}>Commercial</li>
                                <li class={activeFilter === 'residential' ? 'filter-active' : ''} onClick={() => setActiveFilter('residential')}>Residential</li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        {filtered.map(item => (
                            <div key={item.id} class={`col-lg-4 col-md-6 portfolio-item filter-${item.category}`}>
                                <div class="card h-100 shadow-sm">
                                    <img
                                        src={item.images[0]}
                                        class="card-img-top"
                                        style={{ height: '220px', objectFit: 'cover', width: '100%' }}
                                        alt=""
                                        onError={(e) => {
                                            const list = (e.target.dataset.candidates || '').split('|').filter(Boolean);
                                            const idx = parseInt(e.target.dataset.candidateIndex || '0', 10);
                                            const nextIdx = idx + 1;
                                            if (nextIdx < list.length) {
                                                e.target.dataset.candidateIndex = String(nextIdx);
                                                e.target.src = list[nextIdx];
                                            }
                                        }}
                                    />
                                    <div class="card-body d-flex flex-column">
                                        <h5 class="card-title mb-1">{item.title}</h5>
                                        <small class="text-muted mb-2">{item.label}</small>
                                        <p class="card-text" style={{ flex: 1 }}>{item.description}</p>
                                        <div>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-primary me-2"
                                                onClick={() => setSelectedItem(item)}
                                            >
                                                Details
                                            </button>
                                            {/* <button
                                                type="button"
                                                class="btn btn-sm btn-outline-secondary"
                                                onClick={(e) => {
                                                    // const src = e.currentTarget?.closest('.card')?.querySelector('img')?.src || item.imgCandidates[0];
                                                    setZoomImageUrl(item);
                                                }}
                                            >
                                                Preview
                                            </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* {zoomImageUrl && (
                <div class="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.8)' }} tabIndex="-1" onClick={() => setZoomImageUrl(null)}>
                    <div class="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
                        <div class="modal-content" style={{ background: 'transparent', border: 'none' }}>
                            <button type="button" class="btn-close btn-close-white ms-auto me-2 mt-2" aria-label="Close" onClick={() => setZoomImageUrl(null)}></button>

                            {zoomImageUrl?.images.map(img => (
                                <div class="modal-body d-flex justify-content-center">
                                    <img src={img} alt="preview" class="img-fluid" style={{ maxHeight: '80vh' }} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )} */}
            {selectedItem && (
                <div class="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.6)' }} tabIndex="-1" onClick={() => setSelectedItem(null)}>
                    <div class="modal-dialog modal-dialog-centered modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{selectedItem.title}</h5>
                                <button type="button" class="btn-close" aria-label="Close" onClick={() => setSelectedItem(null)}></button>
                            </div>
                            <div class="modal-body">
                                {
                                    selectedItem.images.map(img => <img
                                        src={img}
                                        class="img-fluid mb-3"
                                        alt="detail"
                                    />)
                                }

                                <p class="mb-1"><strong>Category:</strong> {selectedItem.label}</p>
                                <p>{selectedItem.description}</p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" onClick={() => setSelectedItem(null)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </main>
        <Footer/>
        </div>
    )
};

export default Portfolio;